import React from 'react'
import { themeColors } from '../styles/theme'
import Paper from 'material-ui/Paper'
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table'
import Class from 'material-ui/svg-icons/action/class'
import Footer from '../common/Footer'

const styles = {
  title: {
    color: themeColors.positive,
    fontSize: 22,
    marginBottom: 40,
  },
  titleIcon: {
    color: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 10,
  },
  subtitles: {
    fontSize: 18,
    color: themeColors.energized,
    marginTop: 50,
    marginBottom: 10,
  },
  strongText: {
    color: themeColors.energized,
    fontWeight: 'bold',
  },
  tableRow: {
    height: 'none',
    minHeight: '48px',
  },
  tableRight: {
    textOverflow: 'clip',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  tableLeft: {
    fontWeight: 'bold',
  },
  link: {
    wordBreak: 'break-word',
  },
  law: {
    color: themeColors.assertive,
    marginTop: 40,
    fontWeight: 'bold',
  },
}

const PieghiDiLibri = () => (
  <div className="padding">
    <Paper style={{ padding: 20 }}>
      <h3 style={styles.title}>
        <Class style={styles.titleIcon} />
        Guida alla spedizione con modalità "PIEGHI DI LIBRI"
      </h3>
      <p>
        Spedire libri può essere molto costoso dato che il loro peso supera spesso i 350 grammi. Infatti oltre tale peso le tariffe postali non sono più convenienti.
      </p>
      <p>
        <strong>
          Ma c’è una soluzione molto economica: la spedizione "PIEGHI DI LIBRI"!
        </strong>
      </p>
      <p>
        La tipologia di spedizione "Pieghi di Libri" non è particolarmente pubblicizzata, ma se voi la richiedete sono obbligati a farvela.
      </p>
      <h4 style={styles.subtitles}>INFORMAZIONI GENERALI:</h4>
      <p>Questi sono i link al pieghi di libri sul sito delle Poste:</p>
      <ul>
        <li>
          <a
            href="http://www.poste.it/postali/italia/pieghi-libri.shtml"
            rel="noopener noreferrer"
            target="_blank"
            style={styles.link}>
            http://www.poste.it/postali/italia/pieghi-libri.shtml
          </a>
        </li>
        <li>
          <a
            href="http://www.poste-impresa.it/online/pmi/postali/editoria/pieghidilibri.shtml"
            rel="noopener noreferrer"
            target="_blank"
            style={styles.link}>
            http://www.poste-impresa.it/online/pmi/postali/editoria/pieghidilibri.shtml
          </a>
        </li>
        <li>
          <a
            href="http://www.poste-impresa.it/resources/postali/editoriali/postali_pmi/pdf/pieghiLibri_scheda_tecnica_prodotto.pdf"
            rel="noopener noreferrer"
            target="_blank"
            style={styles.link}>
            http://www.poste-impresa.it/resources/postali/editoriali/postali_pmi/pdf/pieghiLibri_scheda_tecnica_prodotto.pdf
          </a>
        </li>
      </ul>
      <p style={styles.strongText}>
        Tale tipologia di spedizione è usufruibile anche dai privati e consente la spedizione di libri e periodici fino a 5 kg di peso a queste tariffe:
      </p>
      <Table style={{ border: '1px solid #E0E0E0' }}>
        <TableBody displayRowCheckbox={false}>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>1,28 €</TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              fino a 2 Kg
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>Ordinario</TableRowColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>4,63 €</TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              fino a 2 Kg
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              Ordinario con diritto di Raccomandazione
            </TableRowColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>3,95 €</TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              fino a 5 Kg
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>Ordinario</TableRowColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>7,30 €</TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              fino a 5 Kg
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              Ordinario con diritto di Raccomandazione
            </TableRowColumn>
          </TableRow>
        </TableBody>
      </Table>
      <p style={styles.strongText}>
        Le tariffe sotto i 2 Kg di peso sono quindi molto convenienti e consentono di spedire libri di peso superiore ai 350 gr a costi contenuti.
      </p>
      <h4 style={styles.subtitles}>SERVIZI ACCESSORI:</h4>
      <p><strong>Avviso di ricevimento: + 0,95 euro</strong></p>
      <p>
        <span style={styles.strongText}>Contrassegno</span>
        {' '}
        (in aggiunta al diritto di raccomandazione di 3,35 euro):
      </p>
      <ul>
        <li>
          per pagamenti effettuati su conto corrente postale: +
          {' '}
          <strong>2,27 €</strong>
        </li>
        <li>
          per pagamenti effettuati a mezzo vaglia: +
          {' '}
          <strong>0,77 €</strong>
          {' '}
          (oltre alla tariffa del vaglia da restituire all'atto del  rimborso)
        </li>
      </ul>
      <p>
        La spedizione ordinaria giunge a destinazione normalmente in 2 o 3 giorni (anche se a volte impiega di più) ma non è tracciata e in caso di smarrimento non è più possibile recuperarla (come la posta prioritaria), mentre quella raccomandata necessita almeno di 5 o 7 giorni, però è tracciata e può essere monitorata in ogni suo passaggio direttamente dal sito delle poste italiane
        {' '}
        <a
          href="http://www.poste.it/online/dovequando/home.do"
          target="_blank"
          rel="noopener noreferrer">
          http://www.poste.it/online/dovequando/home.do
        </a>
        .
        <br />
        La spedizione ordinaria giunge a destinazione normalmente in 2 o 3 giorni (anche se a volte impiega di più) ma non è tracciata e in caso di smarrimento non è più possibile recuperarla (come la posta prioritaria), mentre quella raccomandata necessita almeno di 5 o 7 giorni, però è tracciata e può essere monitorata in ogni suo passaggio direttamente dal sito delle poste italiane
        {' '}
      </p>
      <h4 style={styles.subtitles}>CONFEZIONAMENTO:</h4>
      <p>
        <strong>
          Gli invii devono essere confezionati in modo da essere facilmente verificati. All'esterno della busta deve essere scritto "PIEGHI DI LIBRI".
        </strong>
      </p>
      <p><strong>Formato:</strong></p>
      <ul>
        <li>
          Dimensioni minime: 9 x 14 cm con 5 cm di spessore e, se a forma di rotolo, 10 cm di lunghezza con 3,5 cm di diametro;
        </li>
        <li>
          Dimensioni massime: 45 cm per lato con 5 cm di spessore e, se a forma di rotolo, 75 cm di lunghezza con 10 cm di diametro;
        </li>
        <li>Peso massimo: 5 kg</li>
      </ul>
      <p>
        <small>
          Questo vuol dire che
          {' '}
          <strong>
            è possibile spedire una busta di cm 45 per lato ma con spessore massimo 5 cm
          </strong>
          . Alcuni libri sono piuttosto alti, ma c’è comunque una certa tolleranza per lo spessore, è difficile che vi facciano storie se è di 6 o 7 cm. Cercate comunque per quanto vi è possibile di restare nei 5 cm. Il peso invece va assolutamente rispettato e un lato deve essere facilmente apribile (busta imbottita non chiusa con scotch ma solo con colla) con la dicitura "
          <strong>Lato apribile per ispezione postale</strong>
          ".
        </small>
      </p>
      <p><strong>Trucchi e consigli:</strong></p>
      <p>
        Il libro va inserito in una busta imbottita (pluriball). E’ consigliabile mettere anche due cartoncini sottili ma robusti per evitare che il libro venga danneggiato durante la spedizione. Si chiude la busta, che è autoadesiva, e non si deve mettere scotch perchè bisogna permettere eventualmente l'ispezione postale. Sulla busta si mette l'indirizzo uguale a quello scritto sul bollettino e si scrive ben visibile "Pieghi di Libri".
      </p>
      <p>
        Quando ricevete un pacco speditovi tramite Piego di Libri non buttatelo, riciclatelo! Apritelo dolcemente facendo attenzione che la linguetta con la colla non si strappi, togliete pian piano l’adesivo bianco inserito dall’ufficio postale o i francobolli affrancati, ricoprite con delle etichette l’attuale indirizzo del destinatario e del mittente in modo che possiate scriverci sopra i nuovi dati, spargete un po’ di colla stick lungo tutto il lato della linguetta e chiudetela. In ogni caso non scordatevi che il pacco deve essere comunque apribile per ispezioni postali e che è dunque sconsigliato l’uso dello scotch.
      </p>
      <p>
        E’ consigliabile inserire il mittente con una calligrafia più piccola, in modo che se qualcosa non dovesse andare per il verso giusto, il pacco torni a voi e non si perda nei magazzini delle poste.
      </p>
      <h4 style={styles.subtitles}>
        COSA FARE SE ALL'UFFICIO POSTALE SI RIFIUTANO DI SPEDIRE:
      </h4>
      <p>
        Molti uffici postali non sono informati in merito a questa tipologia di spedizione oppure si rifiutano di effettuarla dicendo che si tratta di tariffe riservate agli editori.
      </p>
      <p>Qualunque cosa vi dicano NON E’ VERO!</p>
      <p>
        La spedizione con pieghi di libri è un diritto di tutti i cittadini italiani, normato dallo Stato Italiano (e non dalle Poste).
      </p>
      <p>
        Questi sono i riferimenti legislativi (stampateli e portateli in posta):
      </p>
      <p style={styles.law}>
        Legge del 23 dicembre 1996, n. 662, art. 2 comma 20
      </p>
      <p>
        (
        <a
          href="http://www.parlamento.it/parlam/leggi/96662l06.htm#2.17"
          rel="noopener noreferrer"
          target="_blank"
          style={styles.link}>
          http://www.parlamento.it/parlam/leggi/96662l06.htm#2.17
        </a>
        )
      </p>
      <p style={{ fontStyle: 'italic' }}>
        Art. 2 - comma 20 - Con decorrenza dal 1° aprile 1997, i prezzi dei servizi di cui al comma 19 sono stabiliti, anche tramite convenzione, dall'Ente poste italiane, tenendo conto delle esigenze della clientela e delle caratteristiche della domanda, nonche' dell'esigenza di difesa e sviluppo dei volumi di traffico. Al fine di agevolare, anche dopo il 1° aprile 1997, gli invii attraverso il canale postale di:
        {' '}
        <br />
        a) libri; <br />
        b) giornali quotidiani e riviste con qualsiasi periodicita' editi da soggetti iscritti al registro nazionale della stampa;
        {' '}
        <br />
        c) pubblicazioni informative di enti, enti locali, associazioni ed altre organizzazioni senza fini di lucro, anche in lingua estera da spedire all'estero;
        <br />
        <span style={{ textDecoration: 'underline' }}>
          il Ministero delle poste e delle telecomunicazioni determina, con un anticipo di almeno tre mesi, le tariffe agevolate per le categorie indicate nelle lettere a), b) e c), con un eventuale aumento non superiore al tasso programmato di inflazione.
          {' '}
        </span>
        <br />
        A tal fine e' istituito un fondo presso la Presidenza del Consiglio dei ministri - Dipartimento per l'informazione e l''editoria pari a lire 300 miliardi per il 1997, per le integrazioni tariffarie da corrispondere all'Ente poste italiane.
        <br />
        Il funzionamento del fondo e' stabilito con decreto del Presidente del Consiglio dei ministri da emanare entro e non oltre il 31 marzo 1997.
        {' '}
        <br />
        Non possono essere ammesse alle tariffe agevolate <br />
        <ul>
          <li>le pubblicazioni pornografiche;</li>
          <li>
            le testate giornalistiche di cui alla lettera b) che contengono inserzioni pubblicitarie, anche in forma di inserto separato dalla pubblicazione, anche di tipo redazionale per un'area calcolata su base annua superiore al 45 per cento dell'intero stampato;
            {' '}
          </li>
          <li>
            le pubblicazioni di cui alla lettera c), qualora includano inserzioni pubblicitarie, anche in forma di inserto separato dalla pubblicazione, o perseguano vantaggi commerciali a favore di terzi, nonche' quelle di vendita per corrispondenza, i cataloghi e la stampa postulatoria.
            {' '}
          </li>
        </ul>
      </p>
      <p style={{ fontStyle: 'italic', marginTop: 0 }}>
        Le stampe promozionali e propagandistiche spedite in abbonamento postale dalle organizzazioni senza scopo di lucro di cui alla lettera c), anche finalizzate alla raccolta di fondi, godono di un trattamento tariffario non superiore all'80 per cento di quello previsto per le pubblicazioni informative delle medesime organizzazioni.
      </p>
      <p style={styles.law}>
        Decreto del Ministero delle Comunicazioni del 13 novembre 2002
      </p>
      <p>
        (
        <a
          href="http://www.uspi.it/tariffepostaliAeB.pdf"
          target="_blank"
          rel="noopener noreferrer">
          http://www.uspi.it/tariffepostaliAeB.pdf
        </a>
        )
      </p>
      <p>
        stabilisce le "Tariffe per la spedizione di invii
        {' '}
        <span style={{ textDecoration: 'underline' }}>
          di libri e di stampe in abbonamento postale di cui alla lettera b) del comma 20 dell'art. 2 della legge 23 dicembre 1996, n. 662.":
        </span>
      </p>
      <p style={{ fontStyle: 'italic' }}>
        Art. 1.<br />
        1. Le tariffe relative agli invii di libri per l'interno mediante pieghi sono stabilite nell'allegato A dal presente decreto:
      </p>
      <p>
        dove la tariffa viene indicata in €/100 pezzi. Ma è possibile spedire anche un solo pezzo!
        Non è scritto in nessun punto che la spedizione dei libri riguarda solo le case editrici (se non per le tariffe ridotte, indicate a parte); le "Tariffe per l'interno per l'invio di pieghi di libri ai sensi della Legge N.662/96, art. 2, comma 20" sono per tutti, privati compresi.
      </p>
      <p style={styles.law}>Legge n. 46 del 27 febbraio 2004</p>
      <p>
        ridefinisce chi può accedere alle tariffe <strong>agevolate</strong>.
      </p>
      <p style={styles.law}>
        Decreto del Ministero delle Comunicazioni del 1 febbraio 2005
      </p>
      <p>
        pubblicato nella Gazzetta Ufficiale - Serie Generale n. 73 del 30-3-2005
      </p>
      <p>riconferma le tariffe della legislazione precedente</p>
      <p style={{ fontStyle: 'italic' }}>
        Art. 1.<br />
        Dal 1° gennaio 2005 e fino all'adozione delle nuove
        {' '}
        <span style={{ textDecoration: 'underline' }}>
          tariffe agevolate postali per la spedizione di prodotti editoriali
        </span>
        {' '}
        ai sensi dell'art. 1, comma 1, del decreto-legge 24 dicembre 2003, n. 353, convertito con la legge 27 febbraio 2004, n. 46, continuano ad applicarsi le tariffe contenute nei decreti del Ministro delle comunicazioni 13 novembre 2002, recanti «Tariffe per la spedizione di invii di libri e di stampe in abbonamento postale di cui alla lettera b) del comma 20 dell'art. 2 della legge 23 dicembre 1996, n. 662», e «Spedizioni di stampe in abbonamento postale di cui alla lettera c) del comma 20 dell'art. 2 della legge 23 dicembre 1996, n. 662», rispettivamente pubblicati nella Gazzetta Ufficiale del 10 dicembre 2002, n. 289, e dell'11 dicembre 2002, n. 290.
      </p>
      <p style={styles.law}>Decreto Legge n. 159 del  1 ottobre 2007,</p>
      <p>
        pubblicato nella Gazzetta Ufficiale n. 229 del 2 ottobre 2007 (INTERVENTI URGENTI IN MATERIA ECONOMICO-FINANZIARIA, PER LO SVILUPPO E L'EQUITA' SOCIALE), art. 10 - Disposizioni concernenti l'editoria, convertito in
      </p>
      <p style={styles.law}>Legge n. 222 del 29 novembre 2007</p>
      <p>
        vengono rivedute le tariffe agevolate per le case editrici.
        {' '}
        <span style={{ textDecoration: 'underline' }}>
          Per la spedizione di libri da parte degli utenti privati non cambia nulla
        </span>
        .
      </p>
      <p style={styles.law}>Decreto interministeriale del 30 Marzo 2010</p>
      <p>
        pubblicato sulla Gazzetta Ufficiale Anno 151 N° 75 del 31 Marzo 2010
      </p>
      <p>
        ha modificato il contesto normativo di riferimento delle spedizioni postali relative al settore editoriale: dal 1 aprile 2010 alle spedizioni editoriali saranno applicate le tariffe
        {' '}
        <strong>non agevolate</strong>
        {' '}
        previste per ciascuna tipologia di spedizione. Secondo la
        {' '}
        <span style={{ fontStyle: 'italic' }}>
          "Comunicazione Interna n. 133"
        </span>
        {' '}
        del 2010 viene soppressa la tariffa "agevolata" o "ridotta" per gli editori e
        {' '}
        <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          ai pieghi di libri sono applicate le tariffe editoriali piene
        </span>
        , che sono fino a 2kg di euro 1,28 e fino a 5 kg di euro 3,95.
        <br />
        <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
          Il decreto non elimina la tariffa Pieghi di Libri, ma elimina solo le tariffe ridotte per gli le case editrici.
        </span>
      </p>
      <p style={styles.law}>Comunicazione Interna n.190 del 05/05/2010</p>
      <p>
        viene indicato agli uffici postali che "[...] i pieghi di libri, per la spedizione di uno o più libri, che possono essere presentati sia da Case Editrici/Librarie o Associazioni e Organizzazioni senza fini di lucro,
        {' '}
        <span style={{ textDecoration: 'underline' }}>
          <strong>sia da soggetti privati</strong>
          {' '}
          DEVONO ESSERE ACCETTATI DAGLI UP
        </span>
        {' '}
        applicando le seguenti tariffe piene: [...]"
      </p>
      <p>
        Se all’ufficio postale si rifiutano di spedire il pieghi di libri, stampate la documentazione sopra riportata e in particolare ditegli di leggere la
        {' '}
        <strong>Comunicazione Interna n.190 del 05/05/2010</strong>
        {' '}
        (i pieghi di libri
        {' '}
        <span style={{ textDecoration: 'underline' }}>
          DEVONO ESSERE ACCETTATI DAGLI UFFICI POSTALI
        </span>
        ).
      </p>
      <p>
        Fategli notare che è indicata anche nel loro tariffario (nella pagina PACCHI PER L'INTERNO e L'ESTERO, in fondo alla prima colonna sotto PACCO ORDINARIO).
      </p>
      <p style={{ marginTop: 30 }}>
        Le tariffe per le case editrici (a destra) sono state modificate dal
        {' '}
        <strong>decreto interministeriale del 30 marzo 2010</strong>
        , mentre le tariffe intere (a sinistra)
        {' '}
        <span style={{ textDecoration: 'underline' }}>
          sono per tutti e sono tuttora valide
        </span>
        .
      </p>
      <p>
        Se vi dicono che è stata soppressa da una circolare delle Poste ribadite che
        {' '}
        <span style={{ textDecoration: 'underline' }}>
          la tariffa è regolamentata da una legge dello Stato
        </span>
        {' '}
        (non dalle Poste).
      </p>
      <p style={{ textDecoration: 'underline' }}>
        La tariffa è presente anche nei loro computer.
      </p>
      <p>Spiegategli il percorso:</p>
      <ul>
        <li>ordinario interno (e' l'unico)</li>
        <li>
          poi pieghi libri ordinario (
          <span style={{ textDecoration: 'underline' }}>
            non pieghi di libri autorizzato
          </span>
          , che è per le case editrici) ed esce automaticamente la tariffa 1,28 euro.
        </li>
      </ul>
      <p style={{ marginTop: 0 }}>
        Se invece volete effettuare il pieghi di libri con diritto di raccomandazione:
      </p>
      <ul>
        <li>stessi passaggi</li>
        <li>poi inserire il codice raccomandata</li>
        <li>
          inserire la localita' ed esce automaticamente la tariffa di 3,63 euro.
        </li>
      </ul>
      <p style={{ marginTop: 0 }}>
        Se ancora si rifiutano, chiedete di parlare con il direttore dell'ufficio postale spiegando quanto scritto sopra.
      </p>
      <p>
        Se non dovesse bastare fate un RECLAMO, utilizzando questo modulo:
        {' '}
        <br />
        <a
          href="https://www.poste.it/risorse/assistenza/pdf/lettera-reclamo.pdf"
          rel="noopener noreferrer"
          target="_blank">
          https://www.poste.it/risorse/assistenza/pdf/lettera-reclamo.pdf
        </a>
        <br />
        preso da questa pagina:<br />
        <a
          href="https://www.poste.it/assistenza/reclami-postali.shtml"
          rel="noopener noreferrer"
          target="_blank">
          https://www.poste.it/assistenza/reclami-postali.shtml
        </a>
      </p>
      <p style={{ marginTop: 0 }}>
        Sezione FUNZIONAMENTO UFFICIO POSTALE: Mancata/errata erogazione servizi, altro: scarsa competenza del personale.
      </p>
      <p>
        Oppure chiedete all'impiegato postale una lettera di reclamo da compilare e spedire
        {' '}
        <strong>per lettera raccomandata con avviso di ricevimento</strong>
        {' '}
        a questo indirizzo:
        {' '}
        <strong>Poste Italiane S.p.A. - Casella Postale 160, 00144 Roma</strong>
      </p>
      <p>
        Oppure, meglio ancora,
        {' '}
        <strong>chiamate il numero verde 803160</strong>
        . Aspettate che l’operatore telefonico vi risponda e informatelo di volere avviare un reclamo a discapito dell’ufficio postale nel quale vi trovate, in quanto si rifiutano di eseguirvi un Pieghi di libri nonostante abbiate presentato moduli e procedure per facilitargli il lavoro. Concludete affermando che il Pieghi di libri è un vostro diritto.
      </p>
    </Paper>
    <Footer />
  </div>
)

export default PieghiDiLibri



// WEBPACK FOOTER //
// ./src/pages/PieghiDiLibri.js